<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="invoiceData"
      dateField="InvoiceDate"
      numberField="SONumber"
    />

    <template v-if="invoiceData.TransactionID !== null">
      <kst-output field="TransactionID" :data="invoiceData" :catalog="Catalog">
        <template #left>
          <kst-output addons controlOff floating-label
            :label="Catalog.TransactionID.AltLabel"
            field="TransactionID" :data="invoiceData" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="TransactionDate" :data="invoiceData" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>

    <template v-if="invoiceData.ClientID">
      <kst-output field="ClientID" :data="invoiceData" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="ClientAlias" :data="invoiceData" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="Client" :data="invoiceData" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="ClientID" :data="invoiceData" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="Client" :data="invoiceData" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="ClientAddress" :data="invoiceData" :catalog="Catalog"/>
    <kst-output field="PONumber" :data="invoiceData" :catalog="Catalog"/>
    <kst-output field="Comment" :data="invoiceData" :catalog="Catalog"/>
    <kst-output field="Status" :data="invoiceData" :catalog="Catalog">
      <template #left v-if="invoiceData.IsPos">
        <div class="k-control-py ks-col-status mr-4">
          <kst-status :value="statusValue" :statusEnum="statusEnum"/>
        </div>
      </template>
    </kst-output>
    <kst-created :data="invoiceData"/>
    <kst-last-updated :data="invoiceData"/>
    <kst-output field="WarehouseID" :data="invoiceData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../InvCatalog.js";
import Model from "../InvModel.js";

export default {
  props: {
    invoiceData: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    statusEnum() {
      return Model.StatusPos;
    },
    statusValue() {
      return Model.StatusPos.Pos.ID;
    }
  }
}
</script>